// convert number to type thousand
function numberFormatToThousand(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default numberFormatToThousand